var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadMedia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "#000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 37.5H7.5V11.25H24.375V7.5H7.5C5.4375 7.5 3.75 9.1875 3.75 11.25V37.5C3.75 39.5625 5.4375 41.25 7.5 41.25H33.75C35.8125 41.25 37.5 39.5625 37.5 37.5V20.625H33.75V37.5ZM19.1438 31.5562L15.4688 27.1313L10.3125 33.75H30.9375L24.3 24.9188L19.1438 31.5562ZM37.5 7.5V1.875H33.75V7.5H28.125C28.1437 7.51875 28.125 11.25 28.125 11.25H33.75V16.8562C33.7687 16.875 37.5 16.8562 37.5 16.8562V11.25H43.125V7.5H37.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadMedia);
export default __webpack_public_path__ + "static/media/upload-media.b73b9cb897d09b40e4256fae0f64fc9e.svg";
export { ForwardRef as ReactComponent };